import axios from "axios"; 

const OTNonAllocatedLocService = {
  // Fetch all purchase orders
  async getAll(date) {
    try {
      const response = await axios.get(`/OTNonAllocatedLoc/GetOTNonAllocatedLoc?p_date=${date}`, {
      // const response = await axios.get(`http://localhost:51976/OTNonAllocatedLoc/GetOTNonAllocatedLoc?p_date=${date}`, {
        headers: {
          
        },
      });

      console.log("API response:", response.data);
      return Array.isArray(response.data.ResultSet) ? response.data.ResultSet : [];
    } catch (error) {
      console.error("Error fetching purchase orders:", error);
      throw error;
    }
  },
}

export default OTNonAllocatedLocService;
